var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass:
        "meeting-note-button h-full flex items-center gap-1.5 hover:bg-blue-900 transition-all",
      class: { "pointer-events-none": _vm.isParticipantRole() },
      on: { click: _vm.onClick },
    },
    [
      _c(
        "div",
        { staticClass: "w-12 h-12 flex justify-center items-center relative" },
        [
          _c("div", {
            staticClass: "w-12 h-12 flex justify-center items-center absolute",
            class: { "animate-glow": _vm.isPending },
          }),
          _c("img", {
            staticClass: "ai_chat_svg",
            attrs: {
              src: require("@/assets/images/meeting-note/ai_chat.svg"),
              alt: "ai_chat.svg",
            },
          }),
          _vm.isOngoingMeetingNote
            ? _c("div", {
                staticClass:
                  "record-background absolute top-0 left-0 w-full h-full",
              })
            : _vm._e(),
          _vm.isOngoingMeetingNote
            ? _c("div", { staticClass: "record-time absolute" }, [
                _vm._v(_vm._s(_vm.meetingNoteDurationForm)),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }